import {Col, Row} from 'antd';
import React from 'react';

import InformativeText from '../../../../constants/InformativeText';
import {convertPxToRem} from '../../../../utils/commonFunctions';
import LabelChart from '../../components/LabelChart';
import TotalChartList from '../../components/TotalChartList';
import ValueRepresentationBox from '../../components/ValueRepresentationBox';
import {rowGutterNZM} from '../../constants/commonConstants';

import AllSuppliers from './AllSuppliers';

const OperationalSupplier: React.FC<{data: any[]}> = ({data}) => {
  const supplyChainInformative = InformativeText?.NZM?.supplyChain;

  return (
    <>
      <Row gutter={rowGutterNZM} style={{height: convertPxToRem(734)}}>
        <Col span={16} style={{height: '100%'}}>
          <AllSuppliers
            data={data}
            keyArray={['top emissions contributors']}
            tooltip={supplyChainInformative.Top_Emission_Contributors}
          />
        </Col>
        <Col span={8} style={{height: '100%'}}>
          <LabelChart
            data={data}
            keyArray={[
              'supplier weightage - total suppliers',
              'high emitters',
              'supplier weightage - medium emitters',
              'supplier weightage - low emitters'
            ]}
            chartType="pieInsideWithTotal"
            tooltip={supplyChainInformative.Supplier_weightage}
            customLabel="TOTAL SUPPLIERS"
          />
        </Col>
      </Row>
      <Row gutter={rowGutterNZM} style={{height: convertPxToRem(481)}}>
        <Col span={20} style={{height: '100%'}}>
          <TotalChartList
            chartType="barReverse"
            showTotal={false}
            keyArray={['transportation mode breakdown']}
            data={data}
            dataInMainData={true}
            showChartList={false}
          />
        </Col>
        <Col span={4} style={{height: '100%'}}>
          <Row gutter={rowGutterNZM}>
            <Col span={24} style={{height: convertPxToRem(230.5)}}>
              <ValueRepresentationBox
                data={data}
                mainKey="percentage suppliers meeting sustainability criteria"
                showTotal={false}
                tooltip={
                  InformativeText?.NZM?.supplyChain
                    .percent_suppliers_meeting_sustainability_criteria
                }
                labelType="percent"
                checkSingle={false}
              />
            </Col>
            <Col span={24} style={{height: convertPxToRem(230.5)}}>
              <ValueRepresentationBox
                data={data}
                mainKey="sustainable suppliers"
                smallImage={true}
                tooltip={
                  InformativeText?.NZM?.supplyChain.Sustainable_suppliers
                }
              />
            </Col>
          </Row>
        </Col>
      </Row>
      <Row gutter={rowGutterNZM} style={{height: convertPxToRem(318)}}>
        <Col span={8}>
          <TotalChartList
            data={data}
            keyArray={[
              'supply chain emissions',
              'upstream supply chain emissions',
              'downstream supply chain emissions'
            ]}
            chartType="pie"
            tooltip={supplyChainInformative.Supply_chain_emission}
          />
        </Col>
        <Col span={8}>
          <TotalChartList
            data={data}
            keyArray={[
              'emissions per unit of goods transported',
              'upstream emissions per unit of goods transported',
              'downstream emissions per unit of goods transported'
            ]}
            chartType="pie"
          />
        </Col>
        <Col span={8}>
          <TotalChartList
            data={data}
            keyArray={[
              'emissions per freight delivered',
              'upstream emissions per freight delivered',
              'downstream emissions per freight delivered'
            ]}
            chartType="pie"
            tooltip={supplyChainInformative.Emissions_per_freight_delivered}
          />
        </Col>
      </Row>
    </>
  );
};

export default OperationalSupplier;
